export default "__VITE_ASSET__BJjJVYqx__"